import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Roster", to: "/roster" },
  { label: "Events", to: "/events" },
  { label: "Shop", to: "/shop" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress(docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-gray-50 border-b border-gray-200"
          : "bg-transparent"
      }`}
    >
      {/* Scroll progress bar */}
      <div
        className="absolute top-0 left-0 h-0.5 bg-gradient-to-r from-orange-500 to-orange-400 transition-all duration-100 pointer-events-none"
        style={{ width: `${scrollProgress}%` }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16 lg:h-20">
        <Link to="/" className="flex-shrink-0">
          <img
            src="https://framerusercontent.com/images/kSUcoz9EYB2x3E5QYqyi2hBJxzQ.png"
            alt="Pacific Wrestling Alliance"
            className="h-8 lg:h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`font-condensed text-base font-semibold uppercase tracking-widest transition-colors duration-200 cursor-pointer whitespace-nowrap relative group ${
                location.pathname === link.to
                  ? "text-orange-500"
                  : scrolled
                  ? "text-gray-900 hover:text-orange-500"
                  : "text-white hover:text-orange-400"
              }`}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-0.5 bg-orange-500 transition-all duration-300 ${
                  location.pathname === link.to ? "w-full" : "w-0 group-hover:w-full"
                }`}
              />
            </Link>
          ))}
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden text-2xl cursor-pointer w-10 h-10 flex items-center justify-center transition-colors ${
            scrolled ? "text-gray-900" : "text-white"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`transition-all duration-300 ${mobileOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-gray-50 border-t border-gray-200 px-6 py-6 flex flex-col gap-5 animate-fade-in-down">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`font-condensed text-lg font-bold uppercase tracking-widest transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === link.to ? "text-orange-500" : "text-gray-900 hover:text-orange-500"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
